// Shared by Vue Router, the preview server and the query-policy checks.
function hasMalformedAmp (query) {
  return /amp(?:;|%3b)/i.test(query)
}

function decode (value) {
  const normalized = value.replace(/\+/g, ' ')
  try {
    return decodeURIComponent(normalized)
  } catch (error) {
    return normalized
  }
}

function isIgnoredKey (key) {
  const name = decode(key)
  return /^(?:__proto__|prototype|constructor|agent)(?:$|\.|\[)/i.test(name) || hasMalformedAmp(name)
}

function sanitizeQuery (query) {
  const clean = Object.create(null)
  if (!query || typeof query !== 'object' || Array.isArray(query)) return clean
  const validValue = value => value === null || (typeof value === 'string' && !hasMalformedAmp(value))
  Object.keys(query).forEach(key => {
    if (isIgnoredKey(key)) return
    const value = query[key]
    if (Array.isArray(value)) {
      const values = value.filter(validValue)
      if (values.length) clean[key] = values
    } else if (validValue(value)) {
      clean[key] = value
    }
  })
  return clean
}

function parseQuery (query) {
  const clean = Object.create(null)
  const raw = query.trim().replace(/^(\?|#|&)/, '')
  if (!raw || hasMalformedAmp(raw)) return clean
  raw.split('&').forEach(parameter => {
    const parts = parameter.split('=')
    const key = decode(parts.shift())
    if (isIgnoredKey(key)) return
    const value = parts.length ? decode(parts.join('=')) : null
    if (!Object.prototype.hasOwnProperty.call(clean, key)) clean[key] = value
    else if (Array.isArray(clean[key])) clean[key].push(value)
    else clean[key] = [clean[key], value]
  })
  return clean
}

function readSavedQuery (storage) {
  try {
    const raw = storage.getItem('utm_mas')
    const parsed = raw ? JSON.parse(raw) : null
    const clean = sanitizeQuery(parsed)
    if (raw && JSON.stringify(clean) !== raw) storage.setItem('utm_mas', JSON.stringify(clean))
    return clean
  } catch (error) {
    try { storage.setItem('utm_mas', '{}') } catch (error) { /* Storage may be disabled. */ }
    return Object.create(null)
  }
}

function malformedQueryRedirect (requestUrl, method) {
  if (!['GET', 'HEAD'].includes(method)) return null
  const separator = requestUrl.indexOf('?')
  if (separator < 0 || !hasMalformedAmp(requestUrl.slice(separator + 1))) return null
  const pathname = requestUrl.slice(0, separator)
  const decodedPath = decode(pathname)
  if (!/^\/(?![/\\])/.test(pathname) || !/^\/(?![/\\])/.test(decodedPath) || /^\/api(?:\/|$)/.test(decodedPath) || /\.php$/i.test(decodedPath)) return null
  return pathname
}

module.exports = { hasMalformedAmp, sanitizeQuery, parseQuery, readSavedQuery, malformedQueryRedirect }
